import * as types from '../types'

const initState = {
  stepNameForm: 'SignIn',
  numberStepForm: 1,
  countStep: 4,
  userData: {},
  blockedFields: {},
  historyStep: ['SignIn'],
  lastForm: false,
  errorSubmitDate: false,
  messageRezult: '',
  showButtonResult: false,
  isClient: false,
  codeStatus: 0,
  scenario: {
    // components: { 
    //   GeneralInformation: { 
    //     default_transition: "Documents",
    //     lastComponent: false,
    //     arr_transition: []
    //   },
    //   Documents: { 
    //     default_transition: "Work",
    //     lastComponent: false,
    //     arr_transition: []
    //   },
    //   Work: { 
    //     default_transition: "Сonfirm",
    //     lastComponent: false,
    //     arr_transition: []
    //   },
    //   Сonfirm: { 
    //     default_transition: "RezultForms",
    //     lastComponent: true,
    //     arr_transition: []
    //   },
    // },
    // firstComponent: 'GeneralInformation',
    // countComponents: 4,
  } 
}

const stateForm = (state = initState, action) => {
  switch(action.type){
    case types.FETCHSCENARIO: {
      return{...state,
        scenario:{
          components: action.scenario.data
        },
        stepNameForm: 'GeneralInformation',
        historyStep: [...state.historyStep, action.scenario.firstComponent],
        countStep: action.scenario.countComponents,
        isClient: action.isClient,
        userData: {
          ...state.userData,
          applicationId: action.idOrder,
          productId: 1,
          phoneCode: '+380',
          phoneKindId: 1,
          phoneType: 1,
          phone: action.phone,
          lastVerificationDate: action.lastVerificationDate,
          salaryPeriod: 1,
          addressTypeId: 1,
          countryId: 804,
          currency: 'UAH',
          term: 12,
          schedule: 'кредитна лінія',
          verifiedFlag: true
        }
      }
    }
    case types.SAVEDATA: {
      const formParams = state.scenario.components[state.stepNameForm]
      const nextForm = formParams.default_transition
      const lastNextComponent =  state.scenario.components[nextForm].lastComponent
      if(!formParams.lastComponent && !action.onlySave)
        return {...state,
          stepNameForm: nextForm,
          historyStep: [...state.historyStep, nextForm],
          numberStepForm: ++state.numberStepForm,
          userData: {...state.userData, ...action.data},
          lastForm: lastNextComponent
        }
      return{...state, userData: {...state.userData, ...action.data}}
    }
    case types.BACKPREVFORM: {
      const newHistory = state.historyStep.slice(0, state.historyStep.length - 1)
      const lastPrevComponent =  state.scenario.components[newHistory[newHistory.length - 1]].lastComponent
      return {...state,
        historyStep: newHistory,
        stepNameForm: newHistory[newHistory.length - 1], 
        numberStepForm: --state.numberStepForm,
        lastForm: lastPrevComponent
      }
    }
    case types.SHOWFORMS:
      return {...state, stepNameForm: 'GeneralInformation', authorization: false}
    case types.SHOWFORMREZULT:
      return {...state,
        stepNameForm: action.name,
        errorSubmitDate: action.errorSubmit,
        historyStep: [...state.historyStep,  action.name],
        numberStepForm: ++state.numberStepForm,
      }
    case types.ERROR:
      return {...state, stepNameForm: 'Crash', codeStatus: action.codeStatus}
    case types.HASREZULT: 
      return {
        ...state,
        stepNameForm: 'RezultForms',
        messageRezult: action.rezult,
        showButtonResult: action.showButtonResult
      }
    case types.SAVE_USER_INFORMATION: {
      const arrParamsCheckBlock = [
        'name',
        'surname',
        'patronymicName',
        'stateCode',
        'birthDay',
        'docTypeId',
        'docSeries',
        'docNumber',
        'docIssueDate',
        'dependentsNumber',
        'liveRegionId',
        'educationId',
        'maritalId'
      ]
      const blockedFields = {}
      arrParamsCheckBlock.forEach(params => {
        // eslint-disable-next-line max-len
        if(action.clientData && action.clientData[params]){
          blockedFields[params] = true
        }
      })
      if(action.clientData && action.clientData.patronymic){
        blockedFields.noSurname = true
      }
      if(typeof action.clientData.docSeries === 'string'
        && typeof action.clientData.docNumber === 'string'
        && !action.clientData.docSeries.length
        && !action.clientData.docNumber.length
        ){
        delete blockedFields.docTypeId
      }

      const getDocTypeId = () => {
        if(action.clientData.docTypeId === 4) return 1
        if(action.clientData.docTypeId === 404) return 2
        // eslint-disable-next-line
        return (action.clientData.docNumber && action.clientData.docNumber.length === 6 ? 1 : 2) || action.clientData.docTypeId
      }

      getDocTypeId()

      return {
        ...state,
        blockedFields,
        userData: {
          ...state.userData,
          ...action.clientData,
          docTypeId: getDocTypeId(),
        }
      }
    }
    default:
      return state
  }
}

export default stateForm